<form
  mat-list-item
  class="bottom-menu"
  #f="ngForm"
  [class.blue-border-top]="isBottomPanelVisible"
>
  <div class="row no-gutters main-row">
    <div
      class="col-md-1 col-lg-1 d-none d-md-flex justify-content-center"
      (click)="uiService.hideBottomPanel()"
    >
      <mat-icon
        class="large-icon"
        svgIcon="close"
        matTooltip="Hide Quick Launch Panel"
      ></mat-icon>
    </div>

    @if (!uiService.shareContentLink()) {
      <div class="col-6 col-md-4 col-lg-3">
        <div class="row no-gutters">
          <div class="col-4 d-none d-md-flex">
            <div class="select-label" matTooltip="Content">
              CONTENT
            </div>
          </div>
          <div class="col-12 col-md-8 multiselect">
            <multiselect
              [config]="configPlaylistsMultiselect"
              [options]="playlists"
              [(value)]="selectedPlaylists"
              [multiple]="false"
              (change)="onPlaylistSelectChanged($event.value)"
            ></multiselect>
          </div>
        </div>
      </div>
    }

    <div class="col-6 col-md-4 col-lg-3">
      <div class="row no-gutters">
        <div class="col-4 d-none d-md-flex">
          <div class="select-label" matTooltip="Monitor(s)">
            MONITOR(S)
          </div>
        </div>
        <div class="col-12 col-md-8 multiselect">
          <multiselect
            [config]="configMonitorsMultiselect"
            [options]="screens"
            [(value)]="selectedScreens"
            [multiple]="true"
            (change)="onMonitorsMultiselectChange($event)"
          ></multiselect>
        </div>
      </div>
    </div>

    <div class="d-flex col" [ngClass]="{'col-md-3 col-lg-5': !uiService.shareContentLink()}">
      @let screensState = screenStateService.getScreensState();

      <div
        matTooltip="Please wait while your request is being processed"
        class="spinner-wrapper"
        *ngIf="screensState.isBusy"
      >
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>

      <mat-icon
        class="cancel-icon"
        *ngIf="screensState.isAnyUploading"
        svgIcon="cancel"
        (click)="onCancelUploading()"
        matTooltip="Cancel uploading">
      </mat-icon>

      @if (uiService.shareContentLink()) {
        <button
          type="button"
          class="buttn btn-blue"
          matTooltip="Share content"
          (click)="onStartSharing(uiService.shareContentLink())"
          [disabled]="!!!selectedScreens.length">
          Share
        </button>
      } @else {
        <button
          type="button"
          *ngIf="screensState.isAllPlaying"
          class="buttn btn-red"
          (click)="onStopPlaylist()"
          matTooltip="Stop"
        >
          Stop
        </button>

        <button
          *ngIf="screensState.isAllWaiting"
          class="buttn btn-green"
          type="button"
          (click)="onStartPlaylist()"
          (mouseleave)="onMouseLeave($event)"
          matTooltip="Play Now"
          [disabled]="!selectedPlaylists?.length"
        >
          Play Now
        </button>

        <button
          (click)="onNewSchedule()"
          *ngIf="selectedScreens?.length && !screensState.isAnyUploading"
          class="buttn btn-gray d-hide"
          type="button"
          matTooltip="Schedule"
          [disabled]="!selectedPlaylists?.length || screensState.isBusy"
        >
          Schedule
        </button>
      }

      <div class="d-none d-md-block pin-icon">
        <mat-icon
          *ngIf="isBottomPanelPinned"
          class="pinned"
          svgIcon="pin_black"
          matTooltip="Unpin Quick Launch Panel"
          (click)="uiService.unpinBottomPanel()"
        ></mat-icon>
        <mat-icon
          *ngIf="!isBottomPanelPinned"
          class="pin"
          svgIcon="pin_white"
          matTooltip="Pin Quick Launch Panel"
          (click)="uiService.pinBottomPanel()"
        ></mat-icon>
      </div>
    </div>
  </div>
</form>
